import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="footer" className="footer position-relative dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <Link to="/" className="logo d-flex align-items-center">
              <img 
                src="/images/logo_dark.png" 
                alt="Rettiyon Global" 
                className="logo-img"
              />
            </Link>
            <div className="footer-contact pt-3">
              <p>Rettiyon Global Private Limited</p>
              <p>3100/2013/61, Ground Floor, Manikath Road</p>
              <p>Ravipuram, Kochi M.g.road</p>
              <p>Ernakulam, Kerala, India, 682016</p>
              <p className="mt-3"><strong>Phone:</strong> <span>+91 6282 392 850</span></p>
              <p><strong>Email:</strong> <span><a href="mailto:info@rettiyonglobal.com">info@rettiyonglobal.com</a></span></p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="#"><i className="bi bi-twitter-x"></i></a>
              <a href="#"><i className="bi bi-facebook"></i></a>
              <a href="#"><i className="bi bi-instagram"></i></a>
              <a href="#"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/services/1">Software Development</Link></li>
              <li><Link to="/services/2">Cloud & DevOps</Link></li>
              <li><Link to="/services/3">UI/UX Design</Link></li>
              <li><Link to="/services/4">Mobile Apps</Link></li>
              <li><Link to="/services/5">System Integration</Link></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Careers</h4>
            <ul>
              <li><Link to="/contact">Open Roles</Link></li>
              <li><Link to="/about">Our Culture</Link></li>
              <li><a href="#">Benefits</a></li>
              <li><a href="#">Remote Work</a></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Legal</h4>
            <ul>
              <li><a href="#">Terms of Service</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Cookie Policy</a></li>
              <li><a href="#">Security</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">Rettiyon Global</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
          Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
